<template>
    <div class="course-info-tab-container" :class="{'mobile-course-info-tab-container':isMobile}">
        <div class="course-info-tab-inner">
            <a-tabs defaultActiveKey="1" :tabBarStyle="{padding:'0 10px',margin:0,textAlign:'center'}">
                <a-tab-pane tab="课程描述" key="1">
                    <div class="course-bottom">
                        <div v-if="!isLoadCourse" v-html="courseInfo.courseDetail"></div>
                        <a-skeleton v-else active />
                    </div>
                </a-tab-pane>
                <a-tab-pane tab="目录" key="2" forceRender>
                    <div class="course-bottom">
                        <section-list :is-course-play="isCoursePlay" />
                    </div>
                </a-tab-pane>
                <a-tab-pane tab="评论" key="3">
                    <div class="course-bottom">
                        <Comment :course-id="$route.params.courseId" :section-id="selectedSection.sectionId"
                                 :isCourse="false" :is-course-play="isCoursePlay"/>
                    </div>
                </a-tab-pane>
            </a-tabs>
        </div>
    </div>
</template>

<script>
    import Comment from "@components/course/Comment";
    import SectionList from "@views/course/components/SectionList";
    import {createNamespacedHelpers} from "vuex";
    import common from "../../../mixin/common";

    const {mapState} = createNamespacedHelpers('course');


    export default {
        name: "CourseInfoTab",
        mixins: [common],
        components: {
            Comment,
            SectionList
        },
        props: {
            isCoursePlay: {
                default: false,
                type: Boolean
            }
        },
        computed: {
            isFree() {
                return this.$func.isTrue(this.courseInfo.isFree)
            },
            isDiscount() {
                return this.$func.isTrue(this.courseInfo.isDiscount)
            },
            ...mapState({
                selectedSection: 'selectedSection',
                courseInfo: 'courseInfo',
                isLoadCourse: "isLoadCourse",
                score: 'score'
            }),
        },
    }
</script>

<style scoped lang="less">
    .course-info-tab-container {
        width: 100%;
        background: white;
    }

    .course-info-tab-inner {
        padding: 0 10px;
    }

    .course-bottom {
        padding: 30px;
    }

    .course-detail {
        background: #F4F4F4;
    }

    // 移动端样式
    .mobile-course-info-tab-container {
        .course-bottom {
            padding: 10px;
        }

        .course-info-tab-inner {
            padding: 0;
        }

        // 移动端课程详情容器
        .mobile-course-desc-container {
            background: #F4F4F4;
            padding-bottom: 10px;

            .mobile-course-desc-inner {
                background: white;
                padding: 10px;

                .mobile-course-desc-info {
                    h4 {
                        font-size: 18px;
                    }

                    > div {
                        span {
                            font-size: 12px;
                        }
                    }
                    border-bottom: 1px solid rgba(221, 221, 221, 0.4);
                    padding-bottom: 10px;
                }

                .mobile-course-desc-price > div {
                    padding: 10px 0 0;
                    display: flex;
                    justify-content: space-between;
                }
            }
        }
    }

    /deep/ .ant-tabs .ant-tabs-bottom-content > .ant-tabs-tabpane-inactive, .ant-tabs .ant-tabs-top-content > .ant-tabs-tabpane-inactive {
        height: 0;
        overflow: hidden;
        opacity: 1;
    }

</style>
